import React from 'react';
import { useHistory } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';

const Auth0ProviderWithHistory = ({ children }) => {
	const domain = process.env.REACT_APP_AUTH0_DOMAIN;
	const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;

	const history = useHistory();

	const onRedirectCallback = appState => {
		// console.log('appState', appState);
		// console.log('returnTo', window.location.pathname);
		// console.log('history', history);
		// console.log('history.location', history.location);
		// console.log('history.location.pathname', history.location.pathname);
		// console.log('window location pathname', window.location);

		history.push(appState?.returnTo || window.location.pathname);
	};

	return (
		<Auth0Provider
			domain={domain}
			clientId={clientId}
			redirectUri={window.location.origin}
			onRedirectCallback={onRedirectCallback}
		>
			{children}
		</Auth0Provider>
	);
};

export default Auth0ProviderWithHistory;
